export const iconFontAwesomeFilesFileCircleExclamation = (
	<i className="fa-solid fa-file-circle-exclamation"></i>
);
